var map = {
	"./google-play-badge-da-DK.svg": 1533,
	"./google-play-badge-de-DE.svg": 9159,
	"./google-play-badge-en-GB.svg": 67781,
	"./google-play-badge-en-US.svg": 85562,
	"./google-play-badge-es-ES.svg": 75337,
	"./google-play-badge-es-MX.svg": 25610,
	"./google-play-badge-fr-FR.svg": 12045,
	"./google-play-badge-it-IT.svg": 31479,
	"./google-play-badge-nb-NO.svg": 17328,
	"./google-play-badge-nl-NL.svg": 52069,
	"./google-play-badge-pl-PL.svg": 97961,
	"./google-play-badge-pt-BR.svg": 64041,
	"./google-play-badge-pt-PT.svg": 13689,
	"./google-play-badge-sv-SE.svg": 38508
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31724;